import { render, staticRenderFns } from "./header-user.vue?vue&type=template&id=eee21ce6&scoped=true&"
import script from "../../js/widgets/header-user.js?vue&type=script&lang=js&"
export * from "../../js/widgets/header-user.js?vue&type=script&lang=js&"
import style0 from "./header-user.vue?vue&type=style&index=0&id=eee21ce6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eee21ce6",
  null
  
)

export default component.exports